import React from 'react';
import { connect } from "react-redux";

import { getBlockIndex, isActiveBlock, isBeforeAfterFlashingBlock, isFlashingBlock } from "../../helpers";
import Block from './Block/Block';
import './Blocks.css';

const blocks = props => {
	let introCount = 0, outroCount = 0, bodyCount = 0, col = 0, blockCSS = "";
	const ordering = {
		'1': 'first',
		'2': 'second',
		'3': 'third',
		'4': 'forth',
		'5': 'fifth'
	};

	const leftColumnBlocks = (
		props.topic.blocks.filter((block, index) => (
			props.currentApp !== 'app-3' ? block.type === 'intro' : index % 5 === 1
		)).map((block, index) => {
			introCount++;
			blockCSS = `square ${ordering[introCount]}-row first-column`;

			return (
				<Block
					key={block.id.toString()}
					block={block}
					css={blockCSS}
					color={props.color[index + 5].join()}
					scriptPlayHandler={props.scriptPlayHandler}
					sequenceIndex={getBlockIndex(props.selectedBlocks, block.id)}
					blockSelector={props.blockSelector}
					selectedId={props.selectedId}
					isActive={isActiveBlock(props.selectedBlocks, block.id)}
					showActiveOnly={props.showActiveOnly}
					index={props.index}
					isFlashing={isFlashingBlock(props.selectedBlocks, block.id)}
					isBeforeAfterFlashing={isBeforeAfterFlashingBlock(props.selectedBlocks, block.id)}
					resumeFlashing={() => props.resumeFlashing()}
					stopFlashing={() => props.stopFlashing()}
					next={props.next}
					setCurrentPlayingId={props.setCurrentPlayingId}
					flashingStatus={props.flashingStatus}
					setMoreInfoStatus={status => props.setMoreInfoStatus(status)}
					moreInfoStatus={props.moreInfoStatus}
					scriptListStatus={props.scriptListStatus}
					isSequencePlaying={props.isSequencePlaying}
					difficultyLevel={props.difficultyLevel}
					disableSlider={status => props.disableSlider(status)}
				/>
			)
		})
	);

	const centerBlocks = (
		props.topic.blocks.filter((block, index) => (
			props.currentApp !== 'app-3' ? block.type === 'body' : (index % 5 === 2 || index % 5 === 3 || index % 5 === 4)
		)).map((block, index) => {
			let bodyCol = "";
			bodyCount++;
			col++;

			if (bodyCount <= 5) {
				bodyCol = "second-column ";
			} else if (bodyCount > 5 && bodyCount <= 10) {
				bodyCol = "third-column ";
			} else {
				bodyCol = "forth-column ";
			}

			blockCSS = `square ${ordering[col]}-row ${bodyCol}`;

			if (bodyCount === 5 || bodyCount === 10) col = 0;

			return (
				<Block
					key={block.id.toString()}
					block={block}
					css={blockCSS}
					color={props.color[index + 5].join()}
					scriptPlayHandler={props.scriptPlayHandler}
					sequenceIndex={getBlockIndex(props.selectedBlocks, block.id)}
					blockSelector={props.blockSelector}
					selectedId={props.selectedId}
					isActive={isActiveBlock(props.selectedBlocks, block.id)}
					showActiveOnly={props.showActiveOnly}
					index={props.index}
					isFlashing={isFlashingBlock(props.selectedBlocks, block.id)}
					isBeforeAfterFlashing={isBeforeAfterFlashingBlock(props.selectedBlocks, block.id)}
					resumeFlashing={() => props.resumeFlashing()}
					stopFlashing={() => props.stopFlashing()}
					next={props.next}
					setCurrentPlayingId={props.setCurrentPlayingId}
					flashingStatus={props.flashingStatus}
					setMoreInfoStatus={status => props.setMoreInfoStatus(status)}
					moreInfoStatus={props.moreInfoStatus}
					scriptListStatus={props.scriptListStatus}
					isSequencePlaying={props.isSequencePlaying}
					difficultyLevel={props.difficultyLevel}
					disableSlider={status => props.disableSlider(status)}
				/>
			)
		})
	);

	const rightColumnBlocks = (
		props.topic.blocks.filter((block, index) => (
			props.currentApp !== 'app-3' ? block.type === 'outro' : index % 5 === 0
		)).map((block, index) => {
			outroCount++;
			blockCSS = `square ${ordering[outroCount]}-row fifth-column`;
			return (
				<Block
					key={block.id.toString()}
					block={block}
					css={blockCSS}
					color={props.color[index + 5].join()}
					scriptPlayHandler={props.scriptPlayHandler}
					sequenceIndex={getBlockIndex(props.selectedBlocks, block.id)}
					blockSelector={props.blockSelector}
					selectedId={props.selectedId}
					isActive={isActiveBlock(props.selectedBlocks, block.id)}
					showActiveOnly={props.showActiveOnly}
					index={index}
					isFlashing={isFlashingBlock(props.selectedBlocks, block.id)}
					isBeforeAfterFlashing={isBeforeAfterFlashingBlock(props.selectedBlocks, block.id)}
					resumeFlashing={() => props.resumeFlashing()}
					stopFlashing={() => props.stopFlashing()}
					next={props.next}
					setCurrentPlayingId={props.setCurrentPlayingId}
					flashingStatus={props.flashingStatus}
					setMoreInfoStatus={status => props.setMoreInfoStatus(status)}
					moreInfoStatus={props.moreInfoStatus}
					scriptListStatus={props.scriptListStatus}
					isSequencePlaying={props.isSequencePlaying}
					difficultyLevel={props.difficultyLevel}
					disableSlider={status => props.disableSlider(status)}
				/>
			)
		})
	);

	return [
		<div className='bottom-left' key={1}>
			<div className='intro-blocks-tooltip-container' />
			{leftColumnBlocks}
		</div>,
		<div className='center-squares' id='bottom-center' key={2}>
			<div className='body-blocks-tooltip-container' />
			{centerBlocks}
		</div>,
		<div className='bottom-right' key={3}>
			<div className='outro-blocks-tooltip-container' />
			{rightColumnBlocks}
		</div>
	]
};

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp
});

export default connect(mapStateToProps)(blocks);
